<template>
    <Page>
        <main>
            <Overlay :image="config.HOME_BACKGROUND_MOBILE || config.HOME_BACKGROUND" dimmed/>
            <transition name="fade">
                <div v-show="!open" class="content">
                    <img :src="config.HOME_LOGO"/>
                    <div class="text">
                        <h2>{{ config.HOME_TITLE }}</h2>
                        <h4 v-if="config.HOME_SUBTITLE">
                            {{ config.HOME_SUBTITLE }}
                        </h4>
                    </div>
                    <Button :color="config.COLOR_PRIMARY" @click="onOpen">
                        {{ config.HOME_CTA }}
                    </Button>
                </div>
            </transition>
        </main>
        <!-- Sign in -->
        <aside :class="asideClasses">
            <transition name="fade">
                <div class="logo">
                    <img v-show="open" :src="config.HOME_LOGO"/>
                </div>
            </transition>
            <transition name="slide-y">
                <SignIn v-show="open" @login="onLogin" @close="onClose"/>
            </transition>
        </aside>
    </Page>
</template>
<script>
import { SolutionConsumer, UserConsumer, CoreConsumer } from '../../mixins';
import { Page, SignIn } from '../../components/mobile';

export default {
    name: 'Home',
    components: { SignIn, Page },
    mixins: [SolutionConsumer, UserConsumer, CoreConsumer],
    data () {
        return {
            open: false,
        };
    },
    computed: {
        asideClasses () {
            return {
                open: this.open,
            };
        },
    },
    created () {
        if (this.user) {
            this.open = true;
        }
    },
    methods: {
        onLogin () {
            this.login();
        },
        onOpen () {
            this.open = true;
        },
        onClose () {
            this.open = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include flex-vertical();
    flex: 1;

    > .content {
        @include container(20px);
        flex: 1;
        position: relative;
        place-items: center;
        justify-content: stretch;
        align-content: center;
        grid-auto-rows: min-content;
        color: $white;

        > img {
            max-height: 100px;
        }

        > .text {
            text-align: center;
            text-shadow: 0 6px 6px rgba($black, .2);

            > h2, > h4 {
                color: $white;
            }
        }
    }
}

aside {
    @include flex-vertical();
    @include cover();
    position: absolute;
    pointer-events: none;
    padding: 20px 20px 0 20px;

    &.open {
        pointer-events: unset;
    }

    > .logo {
        flex: 1 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        > img {
            max-height: 100px;
        }
    }

    > .signin {
        flex: 1 1 auto;
        overflow-y: hidden;
    }
}
</style>
